<template>
  <div id="footer">
    <div>
      <div class="version">
        <p>PEAK Version {{ version }}</p>
        <p>© {{ CurrentYear }} PEAK All rights reserved.</p>
      </div>
      <div class="privacy">
        <!-- <a href="https://peakaccount.com/privacy?param=privacy-section" target="_blank" rel="noopener noreferrer">
          <p>{{ $t("Privacy_policy") }}</p>
        </a>
        <a href="https://peakaccount.com/privacy" target="_blank" rel="noopener noreferrer">
          <p>{{ $t("Conditions_of_use") }}</p>
        </a> -->
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import pkg from "../../../package.json";

@Component
export default class Footer extends Vue {
  private CurrentYear = new Date().getFullYear();
  private version: string = pkg.version;
}
</script>

<style lang="scss" scoped>
#footer {
  position: absolute;
  z-index: -9999;
  right: 0;
  bottom: -85px;
  left: 0;
  > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 70px;
    background: $text;
    padding: 0px 50px;
    .privacy {
      display: flex;
      align-items: center;
      justify-content: space-between;
      p {
        margin-left: 60px;
      }
    }
    .version {
      font-size: 14px;
    }
    p {
      color: white;
      margin: 0;
    }
    @media only screen and (max-width: 1280px) {
      width: 1280px;
    }
  }
}
</style>
